import { number, object } from "yup"

export default object({
  dailyLimit: number().required(),
})
